// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { State, StateT } from '../tbs/state.js';


export class StateEnvelope implements flatbuffers.IUnpackableObject<StateEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StateEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStateEnvelope(bb:flatbuffers.ByteBuffer, obj?:StateEnvelope):StateEnvelope {
  return (obj || new StateEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStateEnvelope(bb:flatbuffers.ByteBuffer, obj?:StateEnvelope):StateEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StateEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

state(obj?:State):State|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new State()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startStateEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addState(builder:flatbuffers.Builder, stateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, stateOffset, 0);
}

static endStateEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStateEnvelope(builder:flatbuffers.Builder, stateOffset:flatbuffers.Offset):flatbuffers.Offset {
  StateEnvelope.startStateEnvelope(builder);
  StateEnvelope.addState(builder, stateOffset);
  return StateEnvelope.endStateEnvelope(builder);
}

unpack(): StateEnvelopeT {
  return new StateEnvelopeT(
    (this.state() !== null ? this.state()!.unpack() : null)
  );
}


unpackTo(_o: StateEnvelopeT): void {
  _o.state = (this.state() !== null ? this.state()!.unpack() : null);
}
}

export class StateEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public state: StateT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const state = (this.state !== null ? this.state!.pack(builder) : 0);

  return StateEnvelope.createStateEnvelope(builder,
    state
  );
}
}
